export default {
  header: {
    logoText: 'Global Hub',
  },
  sections: {
    basicInfo: '募集要項',
    requirements: '応募要件',
    workingConditions: '労働条件',
    salaryBenefits: '給与・福利厚生',
  },
  fields: {
    companyName: '会社名',
    jobType: '職種',
    industry: '業界',
    recruitmentTarget: '採用対象',
    transfer: '転勤',
    urgent: '急募',
    employmentType: '雇用形態',
    employmentPeriod: '雇用期間の定め',
    probationPeriod: '試用期間',
    interviewMethod: '面接方法',
    jobDescription: '業務内容',
    careerPath: 'キャリアパス',
    workplaceAtmosphere: '職場の雰囲気',
    selectionProcess: '選考フロー',
    japaneseLevel: '日本語レベル',
    requiredQualifications: '必須資格（語学以外）',
    requiredSkills: '必須要件',
    preferredSkills: '歓迎要件',
    desiredExperience: '求める経験 / 人物像',
    workplace: '所属先',
    address: '住所',
    nearestStation: '最寄り駅',
    workingHours: '勤務時間・日数',
    holidays: '休日・休暇',
    salary: '給与',
    benefits: '福利厚生',
  },
  values: {
    yes: 'あり',
    no: 'なし',
    isTrue: 'はい',
    isFalse: 'いいえ',
    web: 'Web',
  },
};
